import React from "react";
import PropTypes from "prop-types";
import { enterSpaceHelper } from "../../../shared/accessibilityHelper";

import Image from "../../atoms/Image/Image";
import Typography from "../../atoms/Typography/Typography";
import { BiChevronDown, BiChevronRight } from "react-icons/bi";

import "./CardHeader.scss";

const CardHeader = ({
  title,
  subTitle,
  image,
  isCollapsed,
  collapseHandler,
}) => (
  <div className="cardheader" data-testid="cardheader">
    <div className="cardheader-title">
      <Typography type="h3">{title}</Typography>
      <Typography type="h4">{subTitle}</Typography>
    </div>

    <div className="cardheader-image">
      <div
        onClick={collapseHandler}
        onKeyDown={enterSpaceHelper(collapseHandler)}
        role="button"
        aria-label="Chevron for collapse"
        tabIndex="0"
      >
        {isCollapsed ? <BiChevronRight /> : <BiChevronDown />}
      </div>

      <Image src={image} alt="RoundedImg" width="102" height="56" />
    </div>
  </div>
);

CardHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  collapseHandler: PropTypes.func.isRequired,
};

export default CardHeader;
